import React from 'react';
import { Link } from 'react-router-dom';
import { useReferences } from '../../hooks';
import { Button, Card, CardBody, Spinner, Alert } from '../../components/ui';
import { LinkedDocuments, VerificationBadge } from '../../components';

export const References: React.FC = () => {
  const { references, loading, error, deleteReference, clearError } = useReferences();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl md:text-3xl font-bold min-w-0">References</h1>
        <Link to="/references/add" className="self-start shrink-0">
          <Button>Add Reference</Button>
        </Link>
      </div>

      {error && (
        <Alert variant="danger" onClose={clearError}>
          {error}
        </Alert>
      )}

      {references.length > 0 ? (
        <div className="space-y-4">
          {references.map((ref) => {
            return (
            <Card key={ref.id}>
              <CardBody>
                <div className="min-w-0">
                  <h3 className="font-semibold text-lg break-words">{ref.reference_name}</h3>
                  <div className="mt-1.5">
                    <VerificationBadge status={ref.verification_status} />
                  </div>
                  {ref.relationship && (
                    <p className="text-gray-600 mt-1 break-words">{ref.relationship}</p>
                  )}
                  {ref.company && (
                    <p className="text-gray-500 text-sm break-words">{ref.company}</p>
                  )}
                  {ref.reference_email && (
                    <p className="text-gray-500 text-sm break-words">{ref.reference_email}</p>
                  )}
                  {ref.reference_phone && (
                    <p className="text-gray-500 text-sm">{ref.reference_phone}</p>
                  )}
                  <div className="mt-3">
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => deleteReference(ref.id)}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
                <LinkedDocuments
                  entityId={ref.id}
                  entityType="reference"
                  defaultDocumentType="reference_letter"
                />
              </CardBody>
            </Card>
            );
          })}
        </div>
      ) : (
        <Card>
          <CardBody>
            <div className="text-center py-8">
              <p className="text-gray-500 mb-4">No references added yet</p>
              <Link to="/references/add">
                <Button>Add Your First Reference</Button>
              </Link>
            </div>
          </CardBody>
        </Card>
      )}
    </div>
  );
};
